export default "__VITE_PUBLIC_ASSET__97083b4f__"